import { Row } from '@tanstack/react-table'
import { actionColumn } from '@utils/assessmentReportUtils'
import { Progress } from 'antd'

import { Database_Procs_TeamBonusGames_Item } from '@suntex.fim/api-client'
import { ColumnType, Tooltip } from '@suntex.fim/ui'

import {
  generateScrollableAssessmentCommonColumns,
  renderWrappedAssessmentHeader
} from './CommonColumns'

export const hidableSelectLabel: Record<string, string> = {
  userId: 'User ID',
  displayName: 'Display Name',
  stickers: 'Stickers',
  mol: 'More Or Less',
  first_in_tens_add: 'First In Tens Add',
  first_in_tens_sub: 'First In Tens Sub',
  ten_wheels: 'Ten Wheels',
  link_n_lock_add_sub: 'Link-n-Lock Add Sub',
  shape_shuffle: 'Shape Shuffle',
  early_algebra_tiles: 'Early Algebra Tiles',
  first_to_twenty_add: 'First To 20 Add',
  first_to_twenty_sub: 'First To 20 Sub',
  speed_shuffle: 'Speed Shuffle',
  grand_slam_add_sub: 'Grand Slam A/S',
  deep_seaquence: 'Deep Sea quence',
  touchdown_100_add: 'Go To 100 Add',
  touchdown_100_sub: 'Go To 100 Sub',
  geometry_tiles: 'Geometry Tiles',
  xyz_shuffle: 'XYZ Shuffle',
  decimals_mol: 'Dec More Or Less',
  skip_game: 'Skip Game',
  grand_slam_mul_div: 'Grand Slam M/D',
  factor_wheels: 'Factor Wheels',
  link_n_lock_md: 'Link-n-Lock Mul Div',
  estimation: 'Estimation',
  equivalent_fraction_tiles: 'Equivalent Fraction Tiles',
  vif_tiles: 'VIF Tiles',
  elementary_algebra_tiles: 'Elementary Algebra Tiles',
  ten_wheels_elite: 'Ten Wheels Elite',
  pundis_puzzle: "Pundi's Puzzle",
  fractions_mol: 'Fraction More Or Less',
  the_hex_factor: 'Hex Factor',
  monus_path: "Monu's Path",
  _24_wheels: '24 Wheels',
  misfits_37: 'Misfits 3x7',
  undo_fractions: 'Undo Fractions',
  jennies_jewels: "Jennie's Jewels",
  fraction_wheels: 'Fraction Wheels',
  grand_slam_integers: 'Grand Slam Int',
  rps: 'RPS Chess',
  equivalents: 'Equivalents',
  pattern_puzzle: 'Pattern Puzzle',
  _3_moves_to_0: '3 Moves to Zero',
  monujis_path: "Monuji's Path",
  grand_slam_dec_add_sub: 'Grand Slam Dec Add Sub',
  grand_slam_dec_mul_div: 'Grand Slam Dec Mul Div',
  grand_slam_dec_all: 'Grand Slam Dec All',
  estimation_dec: 'Estimation Dec',
  misfits_37_num: 'Misfits 3x7 Numbers',
  pattern_power: 'Pattern Power',
  decimal_tiles: 'Decimal Tiles',
  integer_tiles: 'Integer Tiles',
  exponent_tiles: 'Exponent Tiles',
  grand_slam_frc_add_sub: 'Grand Slam Frc Add Sub',
  grand_slam_frc_mul_div: 'Grand Slam Frc Mul Div',
  grand_slam_frc_all: 'Grand Slam Frc All',
  link_n_lock_as: 'Link-n-Lock Frc',
  xtreme_algebra: 'Xtreme Algebra',
  algebra_mol: 'Alg More Or Less',
  algebra_tiles: 'Alg Tiles',
  fraction_tiles: 'Fraction Tiles',
  order_of_operations_tiles: 'Order of Operation Tiles',
  rps_master: 'Master RPS Chess',
  grand_slam_alg: 'Grand Slam Alg',
  into_the_vortex: 'Into The Vortex',
  _3_moves_to_0_quantum: 'Quantum Zeroes',
  quantum_algebra: 'Quantum Algebra',
  number_circles: 'Number Circles',
  epic_circles: 'Epic Circles',
  'Bonus 1': 'Bonus 1',
  'Bonus 2': 'Bonus 2',
  'Bonus 3': 'Bonus 3',
  'Bonus 4': 'Bonus 4',
  'Bonus 5': 'Bonus 5',
  'Bonus 6': 'Bonus 6',
  'Bonus 7': 'Bonus 7',
  'Bonus 8': 'Bonus 8'
}
export const getBonusGamesColumnKeys = (level: number) => {
  let columnKeys = ['Bonus 1', 'Bonus 2']
  let subHeaders = [
    [
      'mol',
      'first_in_tens_add',
      'first_in_tens_sub',
      'ten_wheels',
      'link_n_lock_add_sub',
      'shape_shuffle',
      'early_algebra_tiles'
    ],
    [
      'first_to_twenty_add',
      'first_to_twenty_sub',
      'speed_shuffle',
      'grand_slam_add_sub',
      'deep_seaquence',
      'touchdown_100_add',
      'touchdown_100_sub',
      'geometry_tiles',
      'number_circles'
    ]
  ]

  switch (level) {
    case 1:
      columnKeys = ['Bonus 3', 'Bonus 4']
      subHeaders = [
        [
          'xyz_shuffle',
          'decimals_mol',
          'skip_game',
          'grand_slam_mul_div',
          'factor_wheels',
          'link_n_lock_md',
          'estimation',
          'equivalent_fraction_tiles',
          'vif_tiles',
          'elementary_algebra_tiles',
          'ten_wheels_elite'
        ],
        [
          'pundis_puzzle',
          'fractions_mol',
          'the_hex_factor',
          'monus_path',
          '_24_wheels',
          'misfits_37',
          'undo_fractions',
          'jennies_jewels'
        ]
      ]
      break
    case 2:
      columnKeys = ['Bonus 5', 'Bonus 6']
      subHeaders = [
        [
          'fraction_wheels',
          'grand_slam_integers',
          'rps',
          'equivalents',
          'pattern_puzzle',
          '_3_moves_to_0',
          'epic_circles'
        ],
        [
          'monujis_path',
          'grand_slam_dec_add_sub',
          'grand_slam_dec_mul_div',
          'grand_slam_dec_all',
          'estimation_dec',
          'misfits_37_num',
          'pattern_power',
          'decimal_tiles',
          'integer_tiles',
          'exponent_tiles'
        ]
      ]
      break
    case 3:
      columnKeys = ['Bonus 7', 'Bonus 8']
      subHeaders = [
        [
          'grand_slam_frc_add_sub',
          'grand_slam_frc_mul_div',
          'grand_slam_frc_all',
          'link_n_lock_as',
          'xtreme_algebra',
          'algebra_mol',
          'algebra_tiles',
          'fraction_tiles',
          'order_of_operations_tiles'
        ],
        [
          'rps_master',
          'grand_slam_alg',
          'into_the_vortex',
          '_3_moves_to_0_quantum',
          'quantum_algebra'
        ]
      ]
      break
    default:
      columnKeys = ['Bonus 1', 'Bonus 2']
      subHeaders = [
        [
          'mol',
          'first_in_tens_add',
          'first_in_tens_sub',
          'ten_wheels',
          'link_n_lock_add_sub',
          'shape_shuffle',
          'early_algebra_tiles'
        ],
        [
          'first_to_twenty_add',
          'first_to_twenty_sub',
          'speed_shuffle',
          'grand_slam_add_sub',
          'deep_seaquence',
          'touchdown_100_add',
          'touchdown_100_sub',
          'geometry_tiles',
          'number_circles'
        ]
      ]
      break
  }
  return { columnKeys, subHeaders }
}
/**
 * returns JSX for early report table
 */
function columns({
  level,
  graphColor,
  sendMessage
}: {
  level: number
  graphColor: string
  sendMessage: (t: Row<Database_Procs_TeamBonusGames_Item>[]) => void
}) {
  const { columnKeys, subHeaders } = getBonusGamesColumnKeys(level)
  const levelColumns: ColumnType<Database_Procs_TeamBonusGames_Item>[] =
    columnKeys.map((key, index) => ({
      header: key,
      id: key,
      columns: subHeaders[index].map((subKey) => {
        const id = `${subKey}`
        return {
          header: () =>
            renderWrappedAssessmentHeader(`${hidableSelectLabel[id]}`),
          accessorKey: id,
          id,
          size: 110,
          enableSorting: false,
          cell: (info) => (
            <Tooltip
              title={`${Number(info.getValue()) || 0}% complete`}
              classNames={{ root: 'progress-tooltip' }}
              arrow={false}
              placement="right"
            >
              <Progress
                strokeColor={graphColor}
                percent={Number(info.getValue()) || 0}
                size={['100%', 32]}
                showInfo={false}
              />
            </Tooltip>
          )
        }
      })
    }))
  /**
   * handles table column mapping
   */
  const actioncolumn = actionColumn<Database_Procs_TeamBonusGames_Item>(
    hidableSelectLabel,
    sendMessage
  )
  const commonColumns =
    generateScrollableAssessmentCommonColumns<Database_Procs_TeamBonusGames_Item>()

  const finalColumns: ColumnType<Database_Procs_TeamBonusGames_Item>[] = [
    actioncolumn,
    ...commonColumns,
    ...levelColumns
  ]

  return finalColumns
}

export default columns
